<script setup lang="ts">
// BringYourOwnContentGraphic - Polished animated SVG
</script>

<template>
  <svg
    viewBox="14 18 172 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <defs>
      <!-- Subtle soft glow -->
      <filter id="hub-glow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow
          dx="0"
          dy="1"
          stdDeviation="10"
          flood-color="#a78bfa"
          flood-opacity="0.18"
        />
      </filter>

      <!-- Soft radial background -->
      <radialGradient id="hub-gradient" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#c4b5fd" stop-opacity="0.14" />
        <stop offset="100%" stop-color="#c4b5fd" stop-opacity="0" />
      </radialGradient>
    </defs>

    <!-- Flow lines -->
    <path
      d="M68 78 C68 94 82 100 96 104"
      stroke="#ddd6fe"
      stroke-width="1.2"
      stroke-dasharray="3 3"
      stroke-linecap="round"
      fill="none"
      class="dash-flow"
    />
    <path
      d="M132 82 C132 94 118 100 104 104"
      stroke="#ddd6fe"
      stroke-width="1.2"
      stroke-dasharray="3 3"
      stroke-linecap="round"
      fill="none"
      class="dash-flow delay"
    />

    <!-- Video card -->
    <g class="float">
      <rect
        x="46"
        y="45"
        width="44"
        height="33"
        rx="4"
        fill="#f5f3ff"
        stroke="#c4b5fd"
        stroke-width="1.2"
      />
      <circle
        cx="68"
        cy="61.5"
        r="7"
        fill="#ede9fe"
        stroke="#c4b5fd"
        stroke-width="1"
      />
      <path d="M65.5 57.5 L65.5 65.5 L72 61.5 Z" fill="#7c3aed" />
    </g>

    <!-- Document card -->
    <g class="float-delay">
      <rect
        x="110"
        y="49"
        width="44"
        height="33"
        rx="4"
        fill="#ede9fe"
        stroke="#c4b5fd"
        stroke-width="1.2"
      />
      <line
        x1="117"
        y1="58"
        x2="146"
        y2="58"
        stroke="#c4b5fd"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <line
        x1="117"
        y1="66"
        x2="142"
        y2="66"
        stroke="#ddd6fe"
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <line
        x1="117"
        y1="73"
        x2="137"
        y2="73"
        stroke="#ddd6fe"
        stroke-width="1.2"
        stroke-linecap="round"
      />
    </g>

    <!-- Upload hub -->
    <g>
      <!-- Subtle ambient glow -->
      <circle cx="100" cy="106" r="20" fill="url(#hub-gradient)" />

      <g filter="url(#hub-glow)">
        <circle
          cx="100"
          cy="106"
          r="14"
          fill="#f5f3ff"
          stroke="#c4b5fd"
          stroke-width="1"
        />
        <circle cx="100" cy="106" r="9.5" fill="#7c3aed" />
      </g>

      <!-- Cloud upload icon -->
      <g transform="translate(0 -0.5)">
        <path
          d="M96.4 108.7
             H103.6
             C105.1 108.7 106.2 107.7 106.2 106.3
             C106.2 105.1 105.2 104.1 103.9 104.1
             C103.5 102.9 102.4 102 101 102
             C99.3 102 98.1 103.1 97.8 104.5
             C96.3 104.6 95.2 105.7 95.2 107
             C95.2 108 95.9 108.7 96.4 108.7Z"
          fill="none"
          stroke="white"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />

        <path
          d="M100 107.8 L100 104.8"
          stroke="white"
          stroke-width="1.2"
          stroke-linecap="round"
        />

        <path
          d="M98.7 106 L100 104.8 L101.3 106"
          stroke="white"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </g>
  </svg>
</template>

<style scoped>
@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}

@keyframes dash-flow {
  from {
    stroke-dashoffset: 0;
  }
  to {
    stroke-dashoffset: 12;
  }
}

.float {
  animation: float 3s ease-in-out infinite;
}

.float-delay {
  animation: float 3s ease-in-out infinite 0.3s;
}

.dash-flow {
  animation: dash-flow 4s linear infinite;
}

.delay {
  animation-delay: 0.5s;
}
</style>
